import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

const STORAGE_KEY = "luxe_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });
  const [discount, setDiscount] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY + "_discount");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY + "_discount", JSON.stringify(discount));
  }, [discount]);

  const addItem = (product, size, color, quantity = 1) => {
    setItems((prev) => {
      const key = `${product.id}-${size || ""}-${color || ""}`;
      const existing = prev.find(
        (i) => `${i.product_id}-${i.size || ""}-${i.color || ""}` === key
      );
      if (existing) {
        return prev.map((i) =>
          `${i.product_id}-${i.size || ""}-${i.color || ""}` === key
            ? { ...i, quantity: i.quantity + quantity }
            : i
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          price: product.price,
          image: product.images?.[0] || "",
          size,
          color,
          quantity,
        },
      ];
    });
  };

  const updateQty = (index, delta) => {
    setItems((prev) =>
      prev
        .map((i, idx) =>
          idx === index ? { ...i, quantity: Math.max(0, i.quantity + delta) } : i
        )
        .filter((i) => i.quantity > 0)
    );
  };

  const removeItem = (index) => {
    setItems((prev) => prev.filter((_, i) => i !== index));
  };

  const clear = () => {
    setItems([]);
    setDiscount(null);
  };

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const discountAmount = discount ? (subtotal * discount.percent_off) / 100 : 0;
  const total = subtotal - discountAmount;
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider
      value={{
        items,
        addItem,
        updateQty,
        removeItem,
        clear,
        subtotal,
        discountAmount,
        total,
        count,
        discount,
        setDiscount,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
